export enum Events {
    checkout_page_viewed = 'checkout_page_viewed',
    emoji_search_executed = 'emoji_search_executed',
    landing_page_viewed = 'landing_page_viewed',
    purchased = 'purchased',
    user_signup = 'user_signup',
    yat_link_redirect = 'yat_link_redirect',
    yat_minted = 'yat_minted',
    artifact_minted = 'artifact_minted',
}

export enum FantasyEvents {
    fantasy_prod_lineup_viewed = 'fantasy_prod_lineup_viewed',
    fantasy_prod_lineup_started = 'fantasy_prod_lineup_started',
    fantasy_prod_lineup_generate_clicked = 'fantasy_prod_lineup_generate_clicked',
    fantasy_prod_lineup_colln_searched = 'fantasy_prod_lineup_colln_searched',
    fantasy_prod_lineup_submitted = 'fantasy_prod_lineup_submitted',
    fantasy_prod_lineup_named = 'fantasy_prod_lineup_named',
    nav_fantasy_click = 'nav_fantasy_click',
    fantasy_prod_leaderboard_open = 'fantasy_prod_leaderboard_open',
    fantasy_prod_profile_view = 'fantasy_prod_profile_view',
    fantasy_prod_collection_details_view = 'fantasy_prod_collection_details_view',
    // fantasy_prod_submission_view = 'fantasy_prod_submission_view',
    fantasy_alpha_get_latest_game = 'fantasy_alpha_get_latest_game',
    fantasy_alpha_play_click = 'fantasy_alpha_play_click',
}
